import { Compass, Digital, Megaphone, Palette, Public, Target } from "../../assets/icons/icons"
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import './Services.css';

function Services() {

const services = [
  {
    icon: Target,
    title: "Brand Strategy & Consulting",
    description: "Crafting unique brand identities, positioning, and long-term strategies to help your business stand out.",
  },
  {
    icon: Digital,
    title: "Digital Marketing",
    description: "SEO, PPC, social media, and content marketing campaigns designed to maximize online visibility.",
  },
  {
    icon: Megaphone,
    title: "Advertising Campaigns",
    description: "Creative ad design & targeted media buying across Google, Meta, TikTok, and traditional outlets.",
  },
  {
    icon: Public,
    title: "Public Relations & Media Outreach",
    description: "Building trust and reputation through strong media coverage and influencer collaborations.",
  },
  {
    icon: Palette,
    title: "Creative Design & Content",
    description: "High-impact visuals, videos, and copywriting tailored to your brand voice and target audience.",
  },
  {
    icon: Compass,
    title: "Business Consulting",
    description: "Market research, financial modeling, and growth strategy tailored to LA’s dynamic business scene",
  },
];


    return(
        <section className="services-page">
            <div className="services-header">
                <div className="services-content">
                    <h3>
                        Business consulting, Advertising and Marketing agency
                    </h3>
                    <p>
                        Creative, data-driven, and tailored solutions to grow your business in Los Angeles and beyond.
                    </p>
                </div>
            </div>
            <div className="services-cards">
                {services.map((item, index) => (
                    <ServiceCard
                    key={index}
                    icon={item.icon}
                    title={item.title}
                    description={item.description}
                    />
                ))}
            </div>
        </section>
    )

}

export default Services




